import React, { ElementType, ReactNode } from 'react';

import classNames from 'classnames';

import { WithClassName } from '@/blocks/components/types';

import styles from './styles.module.scss';

type CardsGridProps = {
  children?: ReactNode;
  columns?: {
    md?: number;
    lg?: number;
  };
  tag?: ElementType;
  rowAt?: 'md' | 'lg';
} & WithClassName;

/**
 * CardsGrid component.
 *
 * A grid container for cards that can be passed as child elements.
 * Supports configuration of the number of columns and row layout.
 *
 * @param {{ md?: number; lg?: number; }} [columns] - An object specifying the number of columns for different breakpoints.
 * @param {'md' | 'lg'} [rowAt] - The breakpoint at which the grid switches to a row layout.
 * @param columns
 * @param rowAt
 * @param children
 * @param className
 * @param Component
 * @constructor
 */
export function CardsGrid({
  columns = {},
  rowAt,
  children,
  className,
  tag: Component = 'div',
}: CardsGridProps) {
  return (
    <Component
      className={classNames(
        styles.grid,
        {
          [styles.desktopRow]: rowAt === 'lg',
          [styles.tabletRow]: rowAt === 'md',
        },
        className,
      )}
      style={{
        '--columns-md': columns.md || 1,
        '--columns-lg': columns.lg || columns.md || 1,
      }}
    >
      {children}
    </Component>
  );
}
